import { useState } from 'react'
import DownloadOptionsButton from '../../../components/action_button/DownloadOptionsButton'
import ReportExportDialog from './ReportExportDialog'
import { downloadReportPdf, downloadReportSummary } from '../helpers/downloads/reportIndexDownloads'
import { reportExportConfig } from '../helpers/reportExportConfig'
import {
  MAX_ACTIVITY_DOWNLOADS,
  useActiveDownloadCount
} from '../../../components/downloads/fileDownloadStore'
import { activityDownloadLimitHelp } from '../../../constants/fileDownloadConstants'

export default function ReportDownloadDropdown(props) {
  const [exportOpen, setExportOpen] = useState(false)
  const config = reportExportConfig(props.activeTab)
  const activeActivityDownloads = useActiveDownloadCount('activities')
  const activityExportBlocked = activeActivityDownloads >= MAX_ACTIVITY_DOWNLOADS
  const activityLimitHelp = activityDownloadLimitHelp(MAX_ACTIVITY_DOWNLOADS)
  return (
    <>
      <DownloadOptionsButton
        disabled={props.disabled}
        onPrimaryClick={() => downloadReportPdf(props)}
        items={[
          {
            label: `Reporte de usuarios ${config.tabName}`,
            description: 'KPIs, gráficas y tabla de usuarios del periodo, en PDF.',
            onClick: () => downloadReportPdf(props)
          },
          ...(props.activeTab === 'summary'
            ? [
                {
                  label: 'Resumen de usuarios en CSV',
                  description: activityExportBlocked
                    ? activityLimitHelp
                    : 'Resumen básico de usuarios del periodo, en CSV.',
                  disabled: activityExportBlocked,
                  onClick: () => downloadReportSummary(props)
                }
              ]
            : []),
          {
            label: `Reporte de ${config.name} - Todos los usuarios`,
            description: activityExportBlocked
              ? activityLimitHelp
              : 'Cada actividad de tus usuarios, en CSV.',
            disabled: activityExportBlocked,
            onClick: () => setExportOpen(true)
          }
        ]}
      />
      <ReportExportDialog {...props} open={exportOpen} onClose={() => setExportOpen(false)} />
    </>
  )
}
